var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"div-jeu"},[_c('b-container',{staticClass:"bv-example-row"},[(_vm.jeu)?_c('b-row',[_c('span',[_vm._v(_vm._s(_vm.getTitre)+", "+_vm._s(_vm.getAuteurs))])]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }